<template>
    <div>
        <default-navigation></default-navigation>
        <section>
            <div class="custom-container">
                <div class="row">
                    <div class="col-xl-7">
                        <h1 class="mb-5">Disclaimer</h1>
                        <p>De RisicaRadar besteedt veel aandacht aan het up to date houden van deze site en streeft ernaar om alle informatie op deze site goed en foutloos aan te bieden. Desondanks kunnen de samenwerkende fondsen StAG, SoFoKleS en de StAZ geen verantwoordelijkheid of aansprakelijkheid aanvaarden voor het gebruik van informatie op deze site.</p>
                        <p class="mb-5">We behouden ons het recht voor deze website zonder aankondiging tijdelijk of definitief buiten gebruik te stellen. Eventuele aansprakelijkheid wegens schade wordt afgewezen.</p>
                        <router-link to="/" class="btn btn-primary mb-3">Ga naar de homepage</router-link>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: 'Home'
}
</script>
